<div class="selector-container"
     [attr.dir]="rtl ? 'rtl' : 'ltr'"
     [ngClass]="{
       'open': isOpen,
       'empty': !filteredOptions.length && (!create || !search),
       'multiple': multiple,
       'has-value': hasValue(),
       'rtl': rtl,
       'loading': loading,
       'remove-button': removeButton,
       'disabled': disabled
     }">

  <!-- Hidden select for form validation -->
  <select [name]="name"
          [hidden]="true"
          [required]="required && !hasValue()"
          [multiple]="multiple"
          [attr.id]="monId">
    <option *ngFor="let option of selectedValues; trackBy: trackByFn"
            [value]="getObjValue(option, labelAttr)">
      {{getObjValue(option, labelAttr)}}
    </option>
  </select>

  <!-- Input container -->
  <label class="selector-input" (click)="onInputClick()">
    <!-- Selected values display -->
    <ul class="selector-values" *ngIf="!skipModel">
      <li *ngFor="let option of selectedValues; let i = index; trackBy: trackByFn">
        <div>
          <ng-container *ngIf="resolvedViewItemTemplate; else defaultItemTemplate">
            <ng-container *ngTemplateOutlet="resolvedViewItemTemplate; context: { $implicit: option }"></ng-container>
          </ng-container>
          <ng-template #defaultItemTemplate>
            <span>{{getObjValue(option, labelAttr) || option}}</span>
          </ng-template>
        </div>
        <div *ngIf="multiple"
             class="selector-helper"
             (click)="!disabled && unset(i)">
          <span class="selector-icon"></span>
        </div>
      </li>
    </ul>
    @let showPlaceholder = (!skipModel && (!hasValue() || (hasValue() && !hasOption()))) || skipModel;
      <!-- Search input -->
    <input #inputElement
           [name]="name + 'SearchInput'"
           [(ngModel)]="search"
           (ngModelChange)="onSearchChange($event)"
           [attr.placeholder]="showPlaceholder ? placeholder : ''"
           [disabled]="disabled"
           [readonly]="disableSearch"
           [required]="required && !hasValue()"
           autocomplete="off"
           (focus)="onFocus()"
           (blur)="onBlur()"
           (keydown)="onKeydown($event)">

    <!-- Remove button / loading indicator -->
    <div *ngIf="(!multiple || loading) && !skipModel && !hideDropdownIcon"
         class="selector-helper selector-global-helper"
         (click)="!disabled && removeButton && unset()">
      <span class="selector-icon"></span>
      <span class="fas fa-spinner fa-spin fa-fw" aria-hidden="true" *ngIf="loading"></span>
    </div>
  </label>

  <!-- Dropdown -->
  <ul #dropdown
      class="selector-dropdown"
      [style.display]="isOpen || (search) ? 'block' : 'none'"
      (mousedown)="$event.preventDefault()">

    <!-- Create option -->
    <li *ngIf="showCreateOption"
        class="selector-option create"
        [ngClass]="{'active': highlighted === -1}"
        (mouseover)="highlight(-1)"
        (click)="createOption(search)">
      <ng-container *ngIf="dropdownCreateTemplate; else defaultCreateTemplate">
        <ng-container *ngTemplateOutlet="resolveTemplate(dropdownCreateTemplate); context: { $implicit: search }"></ng-container>
      </ng-container>
      <ng-template #defaultCreateTemplate>
        Add <i>{{search}}</i>
      </ng-template>
    </li>

    <!-- Options -->
    <ng-container *ngFor="let option of filteredOptions; let i = index; trackBy: trackByFn">
      <!-- Group header -->
      <li *ngIf="groupAttr && (getObjValue(option, groupAttr) && (i === 0 || getObjValue(filteredOptions[i - 1], groupAttr) !== getObjValue(option, groupAttr)))"
          class="selector-optgroup">
        <ng-container *ngIf="resolvedDropdownGroupTemplate; else defaultGroupTemplate">
          <ng-container *ngTemplateOutlet="resolvedDropdownGroupTemplate; context: { $implicit: option }"></ng-container>
        </ng-container>
        <ng-template #defaultGroupTemplate>
          <span>{{getObjValue(option, groupAttr)}}</span>
        </ng-template>
      </li>

      <!-- Option -->
      <li class="selector-option"
          [ngClass]="{
            'active': highlighted === i,
            'grouped': groupAttr && getObjValue(option, groupAttr)
          }"
          (mouseover)="highlight(i)"
          (click)="set(option)">
        <ng-container *ngIf="resolvedDropdownTemplate; else defaultDropdownTemplate">
          <ng-container *ngTemplateOutlet="resolvedDropdownTemplate; context: { $implicit: option }"></ng-container>
        </ng-container>
        <ng-template #defaultDropdownTemplate>
          <span>{{getObjValue(option, labelAttr) || option}}</span>
        </ng-template>
      </li>
    </ng-container>
  </ul>
</div>

<ng-template #sceDropdownItemTemplate let-option>
  <span *ngIf="option.module === 'accessibility'">
      {{option.short_description}}
  </span>

  <span *ngIf="option.module !== 'accessibility'">
      {{option.title}}
  </span>
</ng-template>

<ng-template #sceSelectTemplate let-option>
  <span *ngIf="option.module === 'accessibility'">
      {{option.short_description}}
  </span>

  <span *ngIf="option.module !== 'accessibility'">
      {{option.title}}
  </span>
</ng-template>

<ng-template #profileSelectItemTemplate let-option let-assignedProfile>
  <div class="row pt-2 flex-nowrap align-items-center profile-item profile-selector-container"
      [ngClass]="{'active-profile-item': option.id === value}">
      <div class="ml-2 col-sm-12 col-lg-8 pl-5">
          <span class="block text-ellipsis" translate>
              Viewing as Profile:
          </span>
          <span class="block text-ellipsis text-bold">
              {{ option.name }}
          </span>
      </div>
      <div class="col-sm-8 d-flex flex-wrap align-items-center">
          <span [ngClass]="['PAGE_PERFORMANCE', 'PROFILE', 'DEVICE'] | monIcons" class="fa-2x hidden-it-on-medium-to-smaller-screen" aria-hidden="true"></span>
          <div class="ml-0 ml-lg-2">
              <span class="block text-ellipsis" translate>
                  Device
              </span>
              <span class="block text-ellipsis text-bold">
                  {{ option.getDeviceName() }}
              </span>
          </div>
      </div>
      <div class="col-sm-8 col-md-10 d-flex flex-wrap align-items-center profile-measure-from-to-the-right">
          <span class="fas fa-map-marker-alt fa-2x hidden-it-on-larger-to-medium-screen" aria-hidden="true"></span>
          <div class="ml-0 ml-lg-2">
              <span class="block text-ellipsis" translate>
                  Measure from
              </span>
              <span class="block text-ellipsis text-bold">
                  <mon-flag-icon flag="{{option.getCountryCode()}}">
                  </mon-flag-icon>
                  <span class="pl-1">{{option.getCountry()}}: {{option.getCity()}}</span>
              </span>
          </div>
      </div>
      <div class="col-sm-8 col-md-10 d-flex flex-wrap align-items-center profile-item-to-the-right hidden-it-on-smaller-screen">
          <span class="fas fa-broadcast-tower fa-2x hidden-it-on-medium-to-smaller-screen" aria-hidden="true"></span>
          <div class="ml-0 ml-sm-5 ml-lg-2">
              <span class="block text-ellipsis" translate>
              Network speed
              </span>
              <span class="block text-ellipsis text-bold">
                  {{ option.getConnectionName() }}
              </span>
          </div>
      </div>
      <div class="col-sm-8 col-md-10 d-flex flex-wrap align-items-center profile-item-to-the-right hidden-it-on-medium-to-smaller-screen">
          <span class="fas fa-history fa-2x hidden-it-on-medium-to-smaller-screen" aria-hidden="true"></span>
          <div class="ml-0 ml-lg-2">
              <span class="block text-ellipsis" translate>
                  Check frequency
              </span>
              <span class="block text-ellipsis text-bold">
                  {{ assignedProfile.scan_frequency | frequencyTranslation }}
              </span>
          </div>
      </div>
  </div>

</ng-template>

<ng-template #profileSelectTemplate let-option let-assignedProfile>
<div class="row pt-2 flex-nowrap align-items-center profile-selector-container">
    <div class="ml-2 col-sm-12 col-lg-8 pl-5">
        <span class="block text-ellipsis" translate>
            Viewing as Profile:
        </span>
        <span class="block text-ellipsis text-bold">
            {{ option.name }}
        </span>
    </div>
    <div class="col-sm-8 d-flex flex-wrap align-items-center ml-1">
        <span [ngClass]="['PAGE_PERFORMANCE', 'PROFILE', 'DEVICE'] | monIcons" class="fa-2x hidden-it-on-medium-to-smaller-screen" aria-hidden="true"></span>
        <div class="ml-0 ml-lg-2">
            <span class="block text-ellipsis" translate>
                Device
            </span>
            <span class="block text-ellipsis text-bold">
                {{ option.getDeviceName() }}
            </span>
        </div>
    </div>
    <div class="col-sm-8 col-md-10 d-flex flex-wrap align-items-center ml-1">
        <span class="fas fa-map-marker-alt fa-2x hidden-it-on-larger-to-medium-screen" aria-hidden="true"></span>
        <div class="ml-0 ml-lg-2">
            <span class="block text-ellipsis" translate>
                Measure from
            </span>
            <span class="block text-ellipsis text-bold">
                <mon-flag-icon flag="{{option.getCountryCode()}}">
                </mon-flag-icon>
                <span class="pl-1">{{option.getCountry()}}: {{option.getCity()}}</span>
            </span>
        </div>
    </div>
    <div class="col-sm-8 col-md-10 d-flex flex-wrap align-items-center ml-1 hidden-it-on-smaller-screen">
        <span class="fas fa-broadcast-tower fa-2x hidden-it-on-medium-to-smaller-screen" aria-hidden="true"></span>
        <div class="ml-0 ml-sm-5 ml-lg-2">
            <span class="block text-ellipsis" translate>
            Network speed
            </span>
            <span class="block text-ellipsis text-bold">
                {{ option.getConnectionName() }}
            </span>
        </div>
    </div>
    <div class="col-sm-8 col-md-10 d-flex flex-nowrap align-items-center ml-1 hidden-it-on-medium-to-smaller-screen">
        <span class="fas fa-history fa-2x" aria-hidden="true"></span>
        <div class="ml-0 ml-lg-2">
            <span class="block text-ellipsis" translate>
                Check frequency
            </span>
            <span class="block text-ellipsis text-bold">
                {{ assignedProfile.scan_frequency | frequencyTranslation }}
            </span>
        </div>
    </div>
</div>

</ng-template>

<ng-template #profileTemplate let-option>
  <div>
      <p class="text-bold">{{option.name}}</p>
      <p *ngIf="option.description">
          {{option.description}}
      </p>
  </div>
</ng-template>

<ng-template #sceDropdownTemplate let-option>
  <span [innerHTML]="option.name"></span>
</ng-template>

<ng-template #domainDropdownItemTemplate let-option>
    <div class="row">
        <div class="col-48 text-ellipsis">
            <img *ngIf="option.type === 'Domain'"
                 [attr.src]="'https://www.google.com/s2/favicons?domain=' + option.url"
                 alt="logo"
                 class="pull-left"/>
            <span *ngIf="option.type === 'DomainGroup'" class="outer-l-small fas fa-clone"></span>
            <span class="inline-block outer-l-mini text-ellipsis">
            {{ option.title }}
        </span>
        </div>
    </div>
</ng-template>

<ng-template #domainSelectTemplate let-option>
    <div class="row">
        <div class="col-48 text-ellipsis">
            <img *ngIf="option.type === 'Domain'"
                 [attr.src]="'https://www.google.com/s2/favicons?domain=' + option.url"
                 alt="logo"
                 class="pull-left"/>
            <span *ngIf="option.type === 'DomainGroup'" class="fas fa-clone"></span>
            <span class="inline-block outer-l-mini">
            {{ option.title }}
        </span>
        </div>
    </div>
</ng-template>

<ng-template #moduleSelectTemplate let-option>
    <div class="inline-block">
        <span class="fa-lg pr-1" [hidden]="!option.icon" [ngClass]="option.icon"></span>
        {{option.name}}
    </div>
</ng-template>

<ng-template #shortcutDropdownItemTemplate let-option>
    <div class="d-flex align-items-center">
        <span class="fa-fw fa-lg" aria-hidden="true" [ngClass]="option.icon"></span>
        <p class="inline-block ml-1 text-ellipsis my-0">
            {{ option.name }}
        </p>
    </div>
</ng-template>

<ng-template #shortcutDropdownViewTemplate let-option>
    <div class="inline-block">
        <div class="d-flex align-items-center">
            <span class="fa-fw fa-lg" aria-hidden="true" [ngClass]="option.icon"></span>
            <p class="inline-block ml-1 text-ellipsis my-0">
                {{ option.name }}
            </p>
        </div>
    </div>
</ng-template>

<ng-template #pagePerformanceProfileLocationTemplate let-option>
    <div class="inline-block">
        <div class="d-flex align-items-center text-ellipsis">
            <mon-flag-icon [flag]="option.country_code"></mon-flag-icon>
            <span class="ml-1 text-ellipsis">
            {{option.country}}: {{ option.city }}
        </span>
        </div>
    </div>
</ng-template>
